import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { ChevronRight } from "lucide-react";
import type { Customer } from "@/hooks/useCustomers";

const TYPE_LABELS: Record<string, string> = {
  general_contractor: "General Contractor",
  property_manager: "Property Manager",
  owner: "Owner",
  insurance_company: "Insurance Co.",
  other: "Other",
};

const SYNC_BADGE: Record<string, { label: string; variant: "default" | "secondary" | "destructive" | "outline" }> = {
  synced: { label: "Synced", variant: "default" },
  pending: { label: "Pending", variant: "secondary" },
  error: { label: "Error", variant: "destructive" },
  not_synced: { label: "Not Synced", variant: "outline" },
};

interface CustomerMobileCardsProps {
  customers: Customer[];
  projectCounts?: Record<string, { total: number; active: number }>;
  onSelect: (c: Customer) => void;
}

export const CustomerMobileCards = ({ customers, projectCounts, onSelect }: CustomerMobileCardsProps) => (
  <div className="space-y-3">
    {customers.map((c) => {
      const pc = projectCounts?.[c.id];
      const activeCount = pc?.active || 0;
      const syncInfo = SYNC_BADGE[c.qb_sync_status || "not_synced"] || SYNC_BADGE.not_synced;
      return (
        <Card key={c.id} className="cursor-pointer active:scale-[0.98] transition-transform" onClick={() => onSelect(c)}>
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  {c.customer_number != null && (
                    <span className="font-mono text-xs text-muted-foreground">#{c.customer_number}</span>
                  )}
                  <p className="font-medium truncate">{c.name}</p>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <Badge variant="outline" className="text-[10px]">{TYPE_LABELS[c.customer_type || "other"] || c.customer_type}</Badge>
                  <Badge variant={syncInfo.variant} className="text-[10px]">{syncInfo.label}</Badge>
                </div>
              </div>
              <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0 mt-1" />
            </div>
            <div className="mt-2 flex items-center justify-between text-sm text-muted-foreground">
              <span>{c.contact_name || c.email || "No contact"}</span>
              {activeCount > 0 ? (
                <Badge variant="secondary" className="text-[10px]">{activeCount} active</Badge>
              ) : (
                <span className="text-xs">0 projects</span>
              )}
            </div>
          </CardContent>
        </Card>
      );
    })}
  </div>
);
